module.exports = __webpack_public_path__ + "img/indicate_icon_1.cedb07dd.png";